<div class="preloader bg-white">
  <img src="./assets/images/preloader.gif" />
</div>
